const apiHeadersReducer = (
    state = {
      data: [],
    },
    action: {
      type: "SET_API_HEADER_LIST";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_API_HEADER_LIST":
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default apiHeadersReducer;
  